import useFilterEntities from '~/services/loop54/hooks/useFilterEntities';
import { EntitiesByAttributeRequest, EntitiesRequest } from '~/services/loop54/types';
import { reduceLoop54Product } from '~/services/loop54/utils';

export default function useFilterResults(
    params: EntitiesByAttributeRequest | EntitiesRequest | undefined,
) {
    return useFilterEntities(params, (data) => ({
        ...data,
        results: reduceLoop54Product(data.results),
    }));
}
